import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import LockerMap from '../components/LockerMap';

export const MapaPage = () => {
  return (
    <main className="pt-20" data-testid="mapa-page">
      {/* Hero */}
      <section className="py-12 bg-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-4"
          >
            <div className="w-14 h-14 bg-lokker-blue rounded-sm flex items-center justify-center">
              <MapPin className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="font-heading font-bold text-3xl text-slate-900">
                Mapa de Lockers
              </h1>
              <p className="text-slate-600">
                Encontre o locker mais próximo de você
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <LockerMap />
          </motion.div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-12 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="bg-white border border-slate-200 p-6 rounded-sm"
            >
              <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2">
                Como usar o mapa
              </h3>
              <p className="text-slate-600 text-sm">
                Clique em um locker para ver detalhes como endereço, horário de funcionamento 
                e quantidade de compartimentos disponíveis.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white border border-slate-200 p-6 rounded-sm"
            >
              <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2">
                Não encontrou um locker perto?
              </h3>
              <p className="text-slate-600 text-sm">
                Estamos em constante expansão! Você pode solicitar a instalação de um locker 
                na sua região através do nosso formulário de contato.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white border border-slate-200 p-6 rounded-sm"
            >
              <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2">
                Quer um locker no seu estabelecimento?
              </h3>
              <p className="text-slate-600 text-sm">
                Se você é empresário e quer oferecer o Use Lokker para seus clientes, 
                entre em contato conosco para uma proposta personalizada.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MapaPage;
